export default "__VITE_ASSET__BUxiuxIw__"